module.exports = __webpack_public_path__ + "static/media/Portrait-10250.30bf3849.jpg";